(function() { window.GUID_91b7651b_9938_45f2_be87_5e1bed42b802 = { getGuid: function() { return "91b7651b-9938-45f2-be87-5e1bed42b802"; } }; })();
var CS;
(function (CS) {
    var CamLight;
    (function (CamLight) {
        var Models;
        (function (Models) {
            var Enums;
            (function (Enums) {
                let BallEventType;
                (function (BallEventType) {
                    BallEventType[BallEventType["Unknown"] = 0] = "Unknown";
                    BallEventType[BallEventType["BallHit"] = 1] = "BallHit";
                    BallEventType[BallEventType["Break"] = 2] = "Break";
                    BallEventType[BallEventType["Fault"] = 3] = "Fault";
                    BallEventType[BallEventType["Safe"] = 4] = "Safe";
                    BallEventType[BallEventType["EmptyInning"] = 5] = "EmptyInning";
                    BallEventType[BallEventType["BackOnTable"] = 6] = "BackOnTable";
                    BallEventType[BallEventType["NoBallHit"] = -2] = "NoBallHit";
                    BallEventType[BallEventType["WhiteScratch"] = -1] = "WhiteScratch";
                })(BallEventType = Enums.BallEventType || (Enums.BallEventType = {}));
            })(Enums = Models.Enums || (Models.Enums = {}));
        })(Models = CamLight.Models || (CamLight.Models = {}));
    })(CamLight = CS.CamLight || (CS.CamLight = {}));
})(CS || (CS = {}));

//# sourceMappingURL=BallEventType.pre.js.map
